import { render, staticRenderFns } from "./BaiDuCallback.vue?vue&type=template&id=4994b45f&scoped=true&"
import script from "./BaiDuCallback.vue?vue&type=script&lang=js&"
export * from "./BaiDuCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994b45f",
  null
  
)

export default component.exports